import {AuthType, AuthTypeEnum, BaseAuthenticationMethod} from './base-authentication-method';

export class Irma extends BaseAuthenticationMethod {
    type = 'irma';
    authtype: AuthType = AuthTypeEnum.AFTERVIEW;
    automaticValidation?: boolean;
    initials?: string; // Only used for preview
    surname?: string; // Only used for preview
    dateofbirth?: Date;
}
